import { useCurrentUploadQuery } from "@/hooks/uploads";
import { AdminView } from "@/components/Admin/AdminView";
import { toRouteError } from "@/errors/routeError";
import Loading from "@ingka/loading";

export const AdminPage = () => {
  const req = useCurrentUploadQuery();

  if (req.isError) {
    throw toRouteError(req.error, { scope: "admin" });
  }

  if (!req.isSuccess) {
    return <Loading text="Loading admin page" />;
  }

  return <AdminView {...req.data!} />;
};
